// extracted by mini-css-extract-plugin
export default {"introBox":"intro_introBox__WkAMl","leftBox":"intro_leftBox__bIlW-","rightBox":"intro_rightBox__sUDwm"};